import React from "react";
import { useLang } from "../lib/lang";
import { Shield } from "lucide-react";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="mt-24 bg-slate-900 text-slate-300" data-testid="site-footer">
      <div className="kn-divider" />
      <div className="max-w-7xl mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 bg-white text-slate-900 flex items-center justify-center">
              <Shield className="w-5 h-5" strokeWidth={1.5} />
            </div>
            <div>
              <div className="font-display text-2xl tracking-wider text-white">{t("brand")}</div>
              <div className="text-[10px] uppercase tracking-[0.3em] text-slate-400">{t("tagline")}</div>
            </div>
          </div>
          <p className="text-sm text-slate-400 max-w-md leading-relaxed">
            Official communications, statements, and updates from the General Headquarters.
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.25em] text-slate-500 mb-4">Sections</div>
          <ul className="space-y-2 text-sm">
            <li>{t("nav_news")}</li>
            <li>{t("nav_gallery")}</li>
            <li>{t("nav_events")}</li>
            <li>{t("nav_about")}</li>
            <li>{t("nav_contact")}</li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.25em] text-slate-500 mb-4">Contact</div>
          <ul className="space-y-2 text-sm text-slate-400">
            <li>press@kawthoolei.org</li>
            <li>General Headquarters</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800 py-6 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} Kawthoolei Army. {t("footer_rights")}
      </div>
    </footer>
  );
}
